import React, { useState,useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useForm } from 'react-hook-form';

// reactstrap components
import { Button, Card, CardBody,FormGroup,Form,Input,Row,Col,Nav,
    NavItem,NavLink,TabPane,TabContent ,Modal,ModalHeader,ModalBody,
    ModalFooter,CustomInput,Tooltip} from "reactstrap";
import MaterialTable from 'material-table';
import Select from 'react-select'

// style
import "assets/css/loading.css";

// services
import { showMessage, showQuestion } from "services/message.js";
import { api_GET, api_POST, api_PUT, api_DELETE } from "services/api_service.js";
import { getSessionCookie } from "services/session.js";
import ValidaAcessoFuncionalidadeAcao from "services/acesso.js";
import CardHeader from "reactstrap/lib/CardHeader";

export default function CadastroFluxoForm({ item, handleReturn }) {
    const { register, handleSubmit, errors, setError, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });
    const [showLoading, setshowLoading] = React.useState(false);
    let session = getSessionCookie();  
    const [permiteEditar, set_permiteEditar] = React.useState(false);

    const [fluxoCadastro_Id, set_fluxoCadastro_Id] = React.useState(0);

    // Configuração de Solicitação
    const [optionsSetupSolicitacao, set_OptionsSetupSolicitacao] = useState([]);
    const [setupSolicitacao, set_setupSolicitacao] = useState(null);
    const loadOptionsSetupSolicitacao = () => {
      let endpoint = "setupsolicitacao";
      if (item == null)
        endpoint += "/GetListByFluxoCadastro";
      api_GET(endpoint).then(result => {
        if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
        }
        else{
          set_OptionsSetupSolicitacao(result.data);
        }
      }); 
    }
    const handleSetupSolicitacao = (value) => {
      set_setupSolicitacao(value);
      setValue("setupSolicitacao", value, true);
      clearErrors("setupSolicitacao");    
    }

    // Ação
    const [setupSolicitacaoAcao, set_setupSolicitacaoAcao] = useState(null);
    const handleSetupSolicitacaoAcao = (value) => {
      set_setupSolicitacaoAcao(value);
      setValue("setupSolicitacaoAcao", value, true);
      clearErrors("setupSolicitacaoAcao");
    }

    // Status
    const [status, set_status] = React.useState("");
    const [options_status] = React.useState([
      {value: "Ativo", label: "Ativo"},
      {value: "Inativo", label: "Inativo"},
    ]);
    const handleStatus = (value) => {
      set_status(value);
      setValue("status", value, true);
      clearErrors("status");
    }      

    const [rowEdit, set_rowEdit] = React.useState(null);
    const [list_table_etapas, set_list_table_etapas] = React.useState([]);

    // Status Etapa
    const [statusEtapa, set_statusEtapa] = React.useState("");
    const handleStatusEtapa = (value) => {
      set_statusEtapa(value);
      clearErrors("statusEtapa");
    }

    // Tipo
    const [tipo, set_tipo] = React.useState("");
    const [options_tipo] = React.useState([
      {value: "Aguardando Análise", label: "Aguardando Análise"},
      {value: "Aguardando Aprovação", label: "Aguardando Aprovação"},
      {value: "Aguardando Compensação", label: "Aguardando Compensação"},
      {value: "Aguardando Aprovação de Guia", label: "Aguardando Aprovação de Guia"},
      {value: "Aguardando Fiscalização", label: "Aguardando Fiscalização"},            
      {value: "Aguardando Diário Oficial", label: "Aguardando Diário Oficial"},
      {value: "Emissão de Guia", label: "Emissão de Guia"},      
      {value: "Publicar Diário Oficial", label: "Publicar Diário Oficial"},
      {value: "Vistoria", label: "Vistoria"},
      //{value: "Solicitar Fiscalização", label: "Solicitar Fiscalização"},
      {value: "Aguardando Enquadramento", label: "Aguardando Enquadramento"}, 
    ]);
    const handleTipo = (value) => {
      set_tipo(value);
      clearErrors("tipo");
    } 

    const handleEditarEtapa = (rowData) => {        
        set_rowEdit(rowData);   
        set_tipo(rowData.tipo);
        set_statusEtapa(rowData.status);
        setValue("ordemEtapa", rowData.ordem);        
        setValue("descricaoEtapa", rowData.descricao);
        setValue("responsividadeEtapa", rowData.prazoResponsividade);     
    }

    // Adicionar Etapa
    const confirmaEtapaAdicionada = (item) => {
      let new_list = [];
      list_table_etapas.map(m => {
          if (m.fluxoCadastroEtapa_Id == item.fluxoCadastroEtapa_Id)
              new_list.push(item);
          else
              new_list.push(m);
      });
      if (list_table_etapas.filter(f => f.fluxoCadastroEtapa_Id == item.fluxoCadastroEtapa_Id).length == 0)
          new_list.push(item);

      set_list_table_etapas(new_list);

      set_rowEdit(null); 
      
      set_tipo("");

      set_statusEtapa("");
      setValue("statusEtapa", "", false);
      setValue("ordemEtapa", "");        
      setValue("descricaoEtapa", "");
      setValue("responsividadeEtapa", "");     
    }

    const handleAdicionarEtapa = () => {
      let data = getValues();
      
      if (fluxoCadastro_Id == 0){
        showMessage("Aviso", "Efetue o cadastro da primeira aba antes de adicionar as etapas!", 'error' , null);
        return;
      }
      
      if (data.ordemEtapa == "" || tipo == "" || data.descricaoEtapa == "" || data.responsividadeEtapa == "" || statusEtapa == ""){
        showMessage("Aviso", "Preencha todos os campos!", 'error' , null);
        return;
      }

      if (list_table_etapas != null && list_table_etapas.filter(f => f.tipo == tipo 
          && (rowEdit == null || (rowEdit != null && f.fluxoCadastroEtapa_Id != rowEdit.fluxoCadastroEtapa_Id))).length > 0){
          showMessage("Aviso", "Já existe outra etapa adicinada com o tipo informado!", 'error' , null);
          return;
      }

      if (list_table_etapas != null && list_table_etapas.filter(f => f.ordem == data.ordemEtapa
          && (rowEdit == null || (rowEdit != null && f.fluxoCadastroEtapa_Id != rowEdit.fluxoCadastroEtapa_Id))).length > 0){
          showMessage("Aviso", "Já existe outra etapa adicinada com esta ordem!", 'error' , null);
          return;
      }
      
      let json_submit = {
          fluxoCadastroEtapa_Id: rowEdit != null ? rowEdit.fluxoCadastroEtapa_Id : 0,
          fluxoCadastro_Id: fluxoCadastro_Id,
          tipo: tipo,
          descricao: data.descricaoEtapa,
          ordem: data.ordemEtapa,
          prazoResponsividade: data.responsividadeEtapa,
          status: statusEtapa,
          usuarioUltimaAlteracao_Id: session.usuario_Id
      }

      setshowLoading(true);
      if(json_submit.fluxoCadastroEtapa_Id == 0){
        api_POST('FluxoCadastro/PostEtapa',json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error' , null);
            }
            else{
                showMessage("Aviso", "Operação executada com sucesso!", 'success' , function(){
                  confirmaEtapaAdicionada(result.data);
                });
            }
        });
      }
      else{
          api_PUT('FluxoCadastro/PutEtapa',json_submit).then(result => {
              setshowLoading(false);
              if (result.status !== 200) {
                  showMessage("Aviso", result.message, 'error' , null);
              }
              else{
                  showMessage("Aviso", "Operação executada com sucesso!", 'success' , function(){
                    confirmaEtapaAdicionada(result.data);
                  });
              }
          });
      }
    }

    // Remover Etapa
    const handleDeleteEtapa = (rowData) => {
      showQuestion("Aviso", "Tem certeza que quer deletar o registro?", 'question' , function(retorno){
        if (retorno){
          setshowLoading(true);
          api_POST('FluxoCadastro/DeleteEtapa', rowData).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error' , null);
            }
            else{
                showMessage("Aviso", "Operação executada com sucesso!", 'success' , null);
                let new_list = list_table_etapas.filter(f => f.fluxoCadastroEtapa_Id != rowData.fluxoCadastroEtapa_Id);
                set_list_table_etapas(new_list);
            }
          });
        }
      });      
    }

    const Voltar = (event, rowData) => {        
      handleReturn();
    }

    const [h1_tab, set_h1_tab] = useState("ht1");    

    const loadItem = () => {
      set_rowEdit(null);
      if (item != null){
          set_fluxoCadastro_Id(item.fluxoCadastro_Id);          
          set_setupSolicitacao(item.setupSolicitacaoAcao.setupSolicitacao);
          setValue("setupSolicitacao", item.setupSolicitacaoAcao.setupSolicitacao, true);
          set_setupSolicitacaoAcao(item.setupSolicitacaoAcao);
          setValue("setupSolicitacaoAcao", item.setupSolicitacaoAcao, true);
          set_status(item.status);                    
          setValue("status", item.status, true);
          set_list_table_etapas(item.fluxoCadastroEtapas);
      }
      else{
          set_fluxoCadastro_Id(0);                  
          set_setupSolicitacao(null);
          setValue("setupSolicitacao", "", false);
          set_setupSolicitacaoAcao(null);
          setValue("setupSolicitacaoAcao", "", false);
          set_status("");                  
          setValue("status", "", false);  
          set_list_table_etapas([]);
      }
    } 

    useEffect(() => {
      ValidaAcessoFuncionalidadeAcao("CadastroFluxo.Editar", function(result){set_permiteEditar(result)});      
      loadOptionsSetupSolicitacao();
      loadItem();
    }, []);

    const onSubmit = (data) => {    
      let json_submit = {
          fluxoCadastro_Id: fluxoCadastro_Id,
          setupSolicitacaoAcao_Id: setupSolicitacaoAcao.setupSolicitacaoAcao_Id,
          status: status,
          usuarioCadastro_Id: session.usuario_Id,
          UsuarioUltimaAlteracao_Id: session.usuario_Id
      }

      setshowLoading(true);
      if(json_submit.fluxoCadastro_Id == 0){
        api_POST('FluxoCadastro',json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error' , null);
            }
            else{
                showMessage("Aviso", "Operação executada com sucesso!", 'success' , function(){
                    set_fluxoCadastro_Id(result.data.fluxoCadastro_Id);
                });
            }
        });
      }
      else{
          api_PUT('FluxoCadastro',json_submit).then(result => {
              setshowLoading(false);
              if (result.status !== 200) {
                  showMessage("Aviso", result.message, 'error' , null);
              }
              else{
                  showMessage("Aviso", "Operação executada com sucesso!", 'success' , null);
              }
          });
      }
    }

    return (
      <>
      {showLoading && 
          <div className="carregandoCmp">
              <div className="box">                
                <img src={require("assets/img/loading.gif")}></img>
              </div>
          </div> 
        }
        <div className="content">
      
            <Row>
                <Col md="12">
                <Button type="button" color="Primary" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
                    <Card className="card-user">
                        <CardHeader>
                          <Row><Col md="12" className="text-right"><label className="text-danger">* Campos Obrigatórios</label></Col></Row>
                        </CardHeader>
                        <CardBody>
                            <Nav pills className="nav-pills-primary" style={{cursor:"pointer"}}>
                                <NavItem>
                                    <NavLink className={h1_tab === "ht1" ? "link-nav active":"link-nav"}onClick={() => set_h1_tab("ht1")}><i class="fas fa-sitemap"></i>  Fluxo de Cadastro </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink style={{margin:"0px 10px"}}className={h1_tab === "ht2" ? "link-nav active":"link-nav"} onClick={() => set_h1_tab("ht2")} ><i class="fas fa-sort-numeric-down"></i>  Etapas </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={h1_tab} className="tab-space tab-principal">
                                <TabPane tabId="ht1">
                                <Row>
                                    <Col md="12">                                        
                                        <Form onSubmit={handleSubmit(onSubmit)} className="formPrincipal">
                                            <Row>
                                                <Col md="6" lg="6">
                                                  <FormGroup>
                                                    <b><label><span className="text-danger">*</span> Setup Solicitação</label> </b>
                                                    <Select
                                                        options={optionsSetupSolicitacao}
                                                        getOptionLabel={option => option.descricao}
                                                        getOptionValue={option => option.setupSolicitacao_Id}
                                                        name="setupSolicitacao"
                                                        onChange={(e) => {handleSetupSolicitacao(e)}}
                                                        value={setupSolicitacao}
                                                        placeholder="Selecione"
                                                        isDisabled={(item != null && item.fluxoCadastro_Id != null) ? true : false}
                                                        ref={e => register(
                                                          { name: "setupSolicitacao" },
                                                          { required: true  })
                                                      }
                                                    />
                                                    {errors.setupSolicitacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                  </FormGroup>
                                                </Col>                                                 
                                                <Col md="4" lg="4">
                                                  <FormGroup>
                                                    <b><label><span className="text-danger">*</span> Ação</label> </b>
                                                    <Select
                                                        options={setupSolicitacao != null && setupSolicitacao.solicitacaoAcoes}
                                                        getOptionLabel={option => option.identificacao}
                                                        getOptionValue={option => option.setupSolicitacaoAcao_Id}
                                                        name="setupSolicitacaoAcao"
                                                        onChange={(e) => {handleSetupSolicitacaoAcao(e)}}
                                                        value={setupSolicitacaoAcao}
                                                        placeholder="Selecione"                                
                                                        isDisabled={(item != null && item.fluxoCadastro_Id != null) ? true : false}
                                                        ref={e => register(
                                                          { name: "setupSolicitacaoAcao" },
                                                          { required: true  })
                                                      }
                                                    />
                                                    {errors.setupSolicitacaoAcao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                  </FormGroup>
                                                </Col>
                                                <Col md="2" lg="2">
                                                    <FormGroup>
                                                      <b><label><span className="text-danger">*</span> Status</label> </b>
                                                      <Select
                                                          options={options_status}
                                                          name="status"
                                                          onChange={(e) => {handleStatus(e.value)}}
                                                          value={status != "" && options_status.find(obj => obj.value === status)}
                                                          placeholder="Selecione"
                                                          ref={e => register(
                                                            { name: "status" },
                                                            { required: true  })
                                                        }
                                                      />
                                                      {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md="12" className="text-center">
                                                    <Button color="success" disabled={!permiteEditar} className="btn-mobile" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                                                </Col>
                                            </Row>
                                        </Form>                                        
                                    </Col>
                                </Row>
                                </TabPane>
                                <TabPane tabId="ht2">
                                  <Row>
                                      <Col md="12">                                          
                                          <Row>
                                              <Col md="2" lg="2">
                                                  <FormGroup>   
                                                      <b><label><span className="text-danger">*</span> Ordem</label> </b>
                                                      <Input type="number" name="ordemEtapa" min={1} innerRef={register()} >
                                                      </Input>
                                                      {errors.ordemEtapaErro && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                  </FormGroup>    
                                              </Col>
                                              <Col md="5">
                                                <FormGroup>
                                                <b><label><span className="text-danger">*</span> Tipo</label> </b>
                                                <Select
                                                    options={options_tipo}
                                                    name="tipo"
                                                    onChange={(e) => {handleTipo(e.value)}}
                                                    value={tipo != "" && options_tipo.find(obj => obj.value === tipo)}
                                                    placeholder="Selecione"                                
                                                    style={{zIndex:"9999"}}
                                                    isDisabled={rowEdit != null ? true : false}
                                                />
                                                {errors.tipo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                              </Col>
                                              <Col md="5">
                                                  <FormGroup>
                                                      <b><label><span className="text-danger">*</span> Descrição</label> </b>
                                                      <Input type="text" name="descricaoEtapa" maxLength={50} innerRef={register()} ></Input>
                                                      {errors.descricaoEtapa && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                  </FormGroup>    
                                              </Col>
                                              <Col md="4" lg="4">
                                                  <FormGroup>   
                                                      <b><label><span className="text-danger">*</span> Prazo de Responsividade (dias)</label> </b>
                                                      <Input type="number" name="responsividadeEtapa" min={1} innerRef={register()} >
                                                      {errors.responsividadeEtapa && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                      </Input>
                                                  </FormGroup>    
                                              </Col>
                                              <Col md="2" lg="2">
                                                  <FormGroup>   
                                                      <b><label><span className="text-danger">*</span> Status</label> </b>
                                                      <Select
                                                          options={options_status}
                                                          name="statusEtapa"
                                                          onChange={(e) => {handleStatusEtapa(e.value)}}
                                                          value={statusEtapa != "" && options_status.find(obj => obj.value === statusEtapa)}
                                                          placeholder="Selecione"                                
                                                      />
                                                      {errors.statusEtapa && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                  </FormGroup>    
                                              </Col>
                                              <Col md="6">
                                                  <Button color="success" disabled={!permiteEditar} className="btn-mobile" type="button" onClick={handleAdicionarEtapa}><i className="fas fa-save"></i> Salvar</Button>
                                              </Col>
                                          </Row>
                                          <Row>
                                              <Col md="12" className="mt-1 mb-4">
                                                <MaterialTable style={{ minHeight: "auto", zIndex: 0 }}
                                                  title=""
                                                  columns={[
                                                    { title: 'Ordem', field: 'ordem', type: 'numeric', cellStyle: {textAlign: "right"} },
                                                    { title: 'Tipo', field: 'tipo' },
                                                    { title: 'Descrição', field: 'descricao' },
                                                    { title: 'Prazo Responsividade', field: 'prazoResponsividade', type: 'numeric', cellStyle: {textAlign: "right"} },
                                                    { title: 'Status', field: 'status'}
                                                  ]}
                                                  data={list_table_etapas}
                                                  isLoading={false}
                                                  options={{
                                                    headerStyle: {
                                                      fontFamily: 'Montserrat, Helvetica Neue, Arial, sans-serif',
                                                      fontWeight: '700',
                                                      color: '#888'
                                                    },
                                                    filtering: false,
                                                    exportButton: true,
                                                    headerStyle: {
                                                      zIndex: -1
                                                    }
                                                  }}
                                                  actions={[                                                    
                                                    {
                                                        icon: 'edit',
                                                        tooltip: 'Editar Registro',
                                                        onClick: (event, rowData) => handleEditarEtapa(rowData)
                                                    },
                                                    {
                                                      icon: 'delete',
                                                      tooltip: 'Deletar Registro',
                                                      onClick: (event, rowData) => handleDeleteEtapa(rowData)
                                                    }
                                                  ]}
                                                  localization={{
                                                    header: {
                                                      actions: 'Ações'
                                                    },
                                                    body: {
                                                      emptyDataSourceMessage: 'Nenhum registro para exibir',
                                                      editRow: {
                                                        cancelTooltip: "Cancelar",
                                                        saveTooltip: "Salvar"
                                                      },
                                                      deleteTooltip: "Excluir",
                                                      editTooltip: "Editar"
                                                    },
                                                    toolbar: {
                                                      searchTooltip: 'Pesquisar',
                                                      searchPlaceholder: 'Pesquisar'
                                                    },
                                                    pagination: {
                                                      labelRowsSelect: 'linhas',
                                                      labelDisplayedRows: '{count} de {from}-{to}',
                                                      firstTooltip: 'Primeira página',
                                                      previousTooltip: 'Página anterior',
                                                      nextTooltip: 'Próxima página',
                                                      lastTooltip: 'Última página'
                                                    }
                                                  }}
                                                />  
                                                </Col>
                                            </Row>   
                                        </Col>
                                    </Row>
                                </TabPane>
                            </TabContent>
                        </CardBody> 
                    </Card>
                </Col>
            </Row>            
        </div>
    
      </>
    );
  }

